module.exports = __webpack_public_path__ + "static/media/HomePage-PromoBanner-text-mobile.0c94e45f.png";